<!--<div class="entry">
    <div class="entry-content">
        <h1>MEET YOUR NEW SALES ASSISTANT</h1>
        <div class="entry-desc">
            <p>Spend more time on meaningful conversations and meet your goals faster by automating the time-consuming and repetitive Sales and Marketing tasks that stifle productivity.</p>
            <p>Connect and close ideal customers using a B2B Customer Graph and buying signals you can't get anywhere else.</p>
        </div>
        <div class="entry-actions">
            <a href routerLink="/home" class="btn btn-default">See how it works</a>
            <a href routerLink="/home" class="btn btn-success">Sign in</a>
        </div>
    </div>
</div>-->
<div class="section-main">
  <div class="d-flex flex-column justify-content-center w-100 h-100">
    <div class="d-flex flex-column justify-content-center align-items-center">
      <h1 class="fw-light text-white m-0 mb-5" style="font-size: 40px;">MEET YOUR NEW SALES ASSISTANT</h1>
      <p class="fw-light text-white m-0 mb-3" style="width: 700px">Spend more time on meaningful conversations and meet your goals faster by automating the time-consuming and repetitive Sales and Marketing tasks that stifle productivity.</p>

      <div class="btn-group my-5">
        <a href routerLink="/buyer-home" class="btn btn-lg btn-outline-light"> See how it works</a>
        <a href routerLink="/buyer-home" class="btn btn-lg btn-outline-light">Sign in </a>
      </div>
      <!--<p class="fw-light text-white m-0" style="width: 400px;">Connect and close ideal customers using a B2B Customer Graph and buying signals you can't get anywhere else.</p>-->
    </div>
  </div>
</div>





